import Card from '~/shared/components/Card';
import PageContainer from '~/shared/components/PageContainer';

import { RoleArn } from './RoleArn';

export default function SettingsPage() {
  return (
    <PageContainer>
      <Card>
        <div className="text-primary-900 opacity-50 text-[14px] font-semibold leading-[24px] mb-[24px]">
          Permissions
        </div>

        <RoleArn />
      </Card>
    </PageContainer>
  );
}
